import React from 'react';
import styles from './EnrollEmptyState.module.scss';

interface EnrollEmptyStateProps {
  description: React.ReactNode;
  ctaLabel: string;
  onCta: () => void;
}

/**
 * Centered empty state used on rescue program pages (GWA, Devices) when the
 * user is not yet enrolled. Renders an upload-style icon, a short description,
 * and a link-styled CTA that typically re-opens the enrollment modal.
 */
export default function EnrollEmptyState({ description, ctaLabel, onCta }: EnrollEmptyStateProps) {
  return (
    <div className={styles.emptyState}>
      <svg className={styles.emptyIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M20 12v6a2 2 0 01-2 2H6a2 2 0 01-2-2v-6" />
        <polyline points="12 3 12 15" />
        <polyline points="8 7 12 3 16 7" />
      </svg>
      <p>{description}</p>
      <button type="button" className={styles.emptyCta} onClick={onCta}>
        {ctaLabel}
      </button>
    </div>
  );
}
